// ADCodeRegistration.jsx - Fixed with working image and complete responsive code
import React from "react";

export default function ADCodeRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            AD Code Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 leading-tight">
            AD Code Registration for Export Customs Clearance
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4 text-lg leading-relaxed">
            Hawkins & Brooks assists exporters with AD Code Registration for
            customs clearance and export transactions through ICEGATE portal and
            bank authorization processes.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed">
            From bank AD Code letter issuance to ICEGATE registration at export
            ports, shipping bill generation, and customs authority coordination,
            the complete process ensures seamless international trade compliance.
          </p>
        </div>

        {/* Right: FIXED WORKING IMAGE - Multiple fallback sources */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100 bg-gray-100">
            <img
              src="https://images.pexels.com/photos/698086/pexels-photo-698086.jpeg?auto=compress&cs=tinysrgb&w=1200&h=1200&fit=crop"
              srcSet="
                https://images.pexels.com/photos/698086/pexels-photo-698086.jpeg?auto=compress&cs=tinysrgb&w=400 400w,
                https://images.pexels.com/photos/698086/pexels-photo-698086.jpeg?auto=compress&cs=tinysrgb&w=800 800w,
                https://images.pexels.com/photos/698086/pexels-photo-698086.jpeg?auto=compress&cs=tinysrgb&w=1200 1200w
              "
              sizes="(max-width: 768px) 100vw, 50vw"
              alt="Export shipping containers and cranes at customs port terminal for AD Code registration"
              className="w-full h-96 md:aspect-square object-cover transition-transform duration-300 hover:scale-105"
              loading="eager"
              onError={(e) => {
                e.target.src = 'https://images.unsplash.com/photo-1558618047-3c8c76bbb17e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80';
              }}
            />
            {/* Fallback SVG placeholder */}
            <svg
              className="w-full h-96 md:aspect-square object-cover absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-300"
              viewBox="0 0 400 400"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="400" height="400" fill="#f8fafc"/>
              <path d="M50 300 L100 250 L150 280 L200 220 L250 260 L300 240 L350 270 L380 290" stroke="#eab308" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
              <path d="M80 320 Q120 340 160 330 Q200 350 240 340 Q280 355 320 345" stroke="#eab308" strokeWidth="6" strokeLinecap="round" fill="none"/>
              <circle cx="200" cy="100" r="40" fill="#f59e0b"/>
              <circle cx="200" cy="100" r="20" fill="#d97706"/>
              <rect x="320" y="50" width="60" height="30" rx="5" fill="#10b981" stroke="#059669" strokeWidth="2"/>
              <text x="330" y="72" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" fill="white">CRANE</text>
            </svg>
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-12 lg:gap-16">
          {/* Documents required */}
          <div className="order-2 md:order-1">
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-6 leading-tight">
              Documents Required for AD Code Registration
            </h2>
            <p className="text-gray-700 mb-8 text-lg leading-relaxed">
              Hawkins & Brooks coordinates with banks and customs for
              complete AD Code documentation and ICEGATE registration.
            </p>
            <div className="bg-gradient-to-br from-yellow-50 to-orange-50 border border-yellow-200 rounded-2xl p-8 shadow-lg">
              <ul className="space-y-4 text-gray-800 text-lg">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0" />
                  <span>IEC certificate (Import Export Code) from DGFT.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0" />
                  <span>Bank authorization letter on bank letterhead as per Customs format.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0" />
                  <span>PAN card of exporter, company, or proprietary business.</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div className="order-1 md:order-2">
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-6 leading-tight">
              Why Choose Hawkins & Brooks?
            </h2>
            <p className="text-gray-700 mb-8 text-lg leading-relaxed">
              The firm specializes in export documentation with expertise in AD
              Code registration across banks and customs authorities.
            </p>
            <div className="space-y-4 mb-10">
              <div className="group border-l-4 border-yellow-500 bg-white/80 backdrop-blur-sm shadow-lg hover:shadow-xl rounded-r-2xl p-6 hover:-translate-x-2 transition-all duration-300 hover:bg-gradient-to-r hover:from-yellow-50 hover:to-orange-50">
                <h3 className="font-bold text-xl text-gray-900 mb-2 group-hover:text-yellow-700 transition-colors">
                  Export Compliance Expertise
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Complete knowledge of AD Code requirements, bank procedures,
                  ICEGATE registration, and customs clearance documentation for
                  seamless export operations.
                </p>
              </div>

              <div className="group border-l-4 border-yellow-500 bg-white/80 backdrop-blur-sm shadow-lg hover:shadow-xl rounded-r-2xl p-6 hover:-translate-x-2 transition-all duration-300 hover:bg-gradient-to-r hover:from-yellow-50 hover:to-orange-50">
                <h3 className="font-bold text-xl text-gray-900 mb-2 group-hover:text-yellow-700 transition-colors">
                  Smooth Customs Registration
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Bank coordination for AD Code letter, ICEGATE portal
                  registration at export ports, shipping bill readiness, and
                  customs authority liaison for swift activation.
                </p>
              </div>

              <div className="group border-l-4 border-yellow-500 bg-white/80 backdrop-blur-sm shadow-lg hover:shadow-xl rounded-r-2xl p-6 hover:-translate-x-2 transition-all duration-300 hover:bg-gradient-to-r hover:from-yellow-50 hover:to-orange-50">
                <h3 className="font-bold text-xl text-gray-900 mb-2 group-hover:text-yellow-700 transition-colors">
                  Reliable Professional Assistance
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  End-to-end export readiness from bank application through AD
                  Code issuance, port registrations, ICEGATE activation, and
                  ongoing customs documentation support.
                </p>
              </div>
            </div>

            {/* Enhanced CTA */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/contact"
                className="group inline-flex items-center justify-center px-8 py-4 rounded-2xl bg-gradient-to-r from-green-500 to-green-600 text-white font-bold shadow-xl hover:shadow-2xl hover:from-green-600 hover:to-green-700 transform hover:-translate-y-1 transition-all duration-300 text-lg tracking-wide"
              >
                <span>Get Consultation</span>
                <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
              <a
                href="tel:+919217468906"
                className="group inline-flex items-center justify-center px-8 py-4 rounded-2xl border-2 border-yellow-500 text-yellow-600 font-bold hover:bg-yellow-500 hover:text-white shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-lg tracking-wide bg-yellow-50"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                Call Now: +91 9217468906
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile responsiveness fix for hero section */}
      <style jsx>{`
        @media (max-width: 768px) {
          .min-h-screen {
            min-height: 100vh;
          }
          img {
            height: 300px !important;
          }
        }
      `}</style>
    </div>
  );
}
